import { useTranslation } from 'react-i18next';

export const keyPrefix = 'detection_overlay';
export const useDetectionOverlayTranslation = () => useTranslation('shared', { keyPrefix });

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    size: 'Размер',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    size: 'Size',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    size: 'Tamanho',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    size: 'Tamaño',
  },
}) : {}) as Record<string, unknown>;
